import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUserAuth } from './IUserAuth';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(
    private router: Router
  ) {
  }

  public tokenExpired(): boolean {
    const expiry = parseInt(localStorage.getItem("expiration"));
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    if (!!!token) {
      return false;
    }

    return true;
  }

  public get user(): IUserAuth {
    return JSON.parse(localStorage.getItem('user'));
  }

  public get token(): string {
    return localStorage.getItem("token");
  }

  public logAuth(): void {
    localStorage.clear();
    //this.router.navigate(['auth'])
    window.location.reload();
  }
}
